module.exports = __webpack_public_path__ + "fonts/713e2f93af8a51d976f24a1552099cd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_green.svg
// module id = 2013
// module chunks = 0